import { css } from 'styled-components';

import { requireImage } from '@nubank/www-latam-commons/utils/requireImage';

function addWebpBackgroundImage(imagePath) {
  return css`
    background-image: url(${requireImage(imagePath, 'webp')});

    .no-webp & {
      background-image: url(${requireImage(imagePath)});
    }
  `;
}

export function handleNotSupportedWebp(...args) {
  return css`
    .no-webp & {
      ${css(...args)}
    }
  `;
}

export default addWebpBackgroundImage;
